
// const REACT_APP_API_URL = " http://54.196.28.253:3005/v1";
const REACT_APP_API_URL = "https://api2.sudhanshumishra.com/v1";
// const REACT_APP_API_URL = " http://localhost:3004/v1";


export default {
  REACT_APP_API_URL,
};
